import React from 'react';
import { InlineLoading } from '@carbon/react';
import { formatQuantity } from 'src/utils/inventory';

interface StockCellProps {
  unit: string;
  stock: number | undefined;
  threshold: number | null | undefined;
}

/** Current stock for the active branch context; red when at/below the low-stock threshold. */
const StockCell = React.memo((props: StockCellProps) => {
  if (props.stock === undefined) {
    return <InlineLoading />;
  }
  const low = props.threshold !== null && props.threshold !== undefined && props.stock <= props.threshold;
  return (
    <span style={low ? { color: 'var(--cds-text-error)', fontWeight: 600 } : undefined}>
      {formatQuantity(props.stock, props.unit)}
    </span>
  );
});

export default StockCell;
